import { render, staticRenderFns } from "./bao-cao-doanh-thu-khach-hang.vue?vue&type=template&id=60700c33&scoped=true&"
import script from "./bao-cao-doanh-thu-khach-hang.vue?vue&type=script&lang=js&"
export * from "./bao-cao-doanh-thu-khach-hang.vue?vue&type=script&lang=js&"
import style0 from "./bao-cao-doanh-thu-khach-hang.vue?vue&type=style&index=0&id=60700c33&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../nguonhangchina/admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60700c33",
  null
  
)

export default component.exports